import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)


const requireAuth = function (to, from, next) {
  if (!store.getters['auth/isLoggedIn']) {
      next({ name: 'login', query: { redirect: to.fullPath } })
  } else {
      next()
  }
}

const requireGuest = function (to, from, next) {
  if (store.getters['auth/isLoggedIn']) {
      next({ name: 'user' })
  } else {
      next()
  }
}

const logout = function (to, from, next) {
  store.dispatch('auth/logout')
  next({ name: 'login' })
}


const routes = [
  {
    path: '/',
    name: 'home',
    redirect: { name: 'projects' },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    beforeEnter: requireGuest,
  },
  {
    path: '/projecten',
    name: 'projects',
    component: () => import('@/views/Projects.vue'),
    beforeEnter: requireAuth,
    meta: { title: 'Projecten' },
  },
  {
    path: '/project/:projectId',
    name: 'project',
    component: () => import('@/views/Project.vue'),
    beforeEnter: requireAuth,
    meta: { title: 'Projecten' },
  },
  {
    path: '/project-regel/:lineId',
    name: 'project-line',
    component: () => import('@/views/ProjectLine.vue'),
    beforeEnter: requireAuth,
    meta: { title: 'Projecten' },
  },
  {
    path: '/gebruikers',
    name: 'users',
    component: () => import('@/views/Users.vue'),
    beforeEnter: requireAuth,
    meta: { title: 'Gebruikers' },
  },
  {
    path: '/uitloggen',
    name: 'logout',
    beforeEnter: logout,
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

export default router
